import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, mergeProps as _mergeProps, createBlock as _createBlock, withCtx as _withCtx } from "vue"

import {computed, toRef} from 'vue'
import {AgBoxS} from '@/components/ag'
import OpenClubDeal from './OpenClubDeal.vue'

export default /*#__PURE__*/_defineComponent({
  props: {
  isLogin: {default: false, type: Boolean},
  list: {default: () => ([]), type: Array},
  totalStockCount: {default: 0, type: Number},
},
  emits: ['like', 'open'],
  setup(__props, { emit: emits }) {

const props = __props





const totalStockCount = toRef(props, 'totalStockCount')
const list = toRef(props, 'list')

const computedList = computed(() => {
  return list.value.map((item: any) => {
    return {
      author: item.sellerInviteCode,
      createAt: item.updateAtTime,
      id: String(item.partnershipId),
      isLike: Boolean(item.partnershipLikeId),
      kind: item.partnershipStatus,
      likeCount: Number(item.likeCount ?? 0),
      messageCount: Number(item.count ?? 0),
      name: item.partnershipName,
      pricePerStock: Number(item.purchasePrice ?? 0),
      stockCount: Number(item.totalQty ?? 0),
      totalStockCount: totalStockCount.value,
    }
  })
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(AgBoxS), { css: {dp: 'flex', direction: 'column'} }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(computedList), (item) => {
        return (_openBlock(), _createBlock(OpenClubDeal, _mergeProps({
          key: item.id,
          "is-login": __props.isLogin
        }, item, {
          onOpen: _cache[0] || (_cache[0] = ($event: any) => (emits('open', $event))),
          onLike: _cache[1] || (_cache[1] = ($event: any) => (emits('like', $event)))
        }), null, 16, ["is-login"]))
      }), 128))
    ]),
    _: 1
  }))
}
}

})